import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Decorador = () => {
  const wpp = generateWhatsAppLink('decorador', 'decorador-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Decoradores | Sustenta LED</title>
        <meta name="description" content="LED para decoradores: soluções decorativas e técnicas. Somos atacadistas e distribuidores com suporte para projetos." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Decoradores</h1>
              <p>Atendemos decoradores com soluções de iluminação LED para valorizar ambientes com estética e conforto visual. Somos atacadistas e distribuidores com linhas decorativas e técnicas.</p>
              <p>Orientamos temperaturas de cor, IRC e modelos adequados para residências, comerciais e projetos especiais.</p>
              <p>Receba atendimento consultivo e condições exclusivas para seus projetos.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_quemsomos_sustentaled.jpg" alt="LED para Decoradores - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Decorador;
